<template>
  <div>
    <QServFilterHouseComp :compProps="{fromDate: fromDate, toDate: toDate}" :payLoad="payLoad" :compIndex="compIndex" @finish="finishHandle"></QServFilterHouseComp>
  </div>
</template>
<script>
/* eslint-disable */
import QServFilterHouseComp from './QServFilterHouseComp'
import { fetchSearchLableMapping } from '@/services/filterTab'
import { 
  QFetchFavirote,
  QFetchFaviroteList,
  qFetchHouseWithFilter
 } from '@/services/q_house'
import { Sniff } from '@/utils/q_sniff'
import { format, formatText } from '@/utils/q_business'
import sendLog from '@/utils/q_log'
import { convertPinyin } from '@/utils/convertPinyin'
import { eventBus } from '@/utils'

const ONE_DAY = 1000 * 60 * 60 * 24 // 一天的时间戳

export default {
  components: {
    QServFilterHouseComp
  },
  data() {
    return {
      labelStrategyMappings: [],
      cityList: [],
      curCity: {},
      curFilter: {},
      themeFilters: [],
      labelKeys: [],
      fromDate: '',
      toDate: ''
    }
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    payLoad(newVal) {
      const actionType = newVal.type
      switch(actionType) {
        case 'changeCity':
        {
          const logParam = {
            actPos: `${this.compIndex}_1_${newVal.newCity.cityId}`,
            actPage: `cms_${this.$root.promotionId}`,
            actText: `cms_${this.$root.promotionId}_filter`
          }
          sendLog(logParam)
          this.changeCity(newVal.newCity)
          break
        }
        case 'changeFilter':
        {
          const logParam = {
            actPos: `${this.compIndex}_2_${newVal.newFilter.index + 1}`,
            actPage: `cms_${this.$root.promotionId}`,
            actText: `cms_${this.$root.promotionId}_filter`
          }
          sendLog(logParam)
          this.changeFilter(newVal.newFilter)
          break
        }
        case 'changeSubFilter':
        {
          const logParam = {
            actPos: `${this.compIndex}_3_${newVal.clickIndex + 1}`,
            actPage: `cms_${this.$root.promotionId}`,
            actText: `cms_${this.$root.promotionId}_filter`
          }
          sendLog(logParam)
          this.changeSubFilter(newVal.newSubFilters)
          break
        }
        case 'loadMore':
          this.loadMore(newVal.data)
          break
        // 子servComp组件处理的变更事件，可以不用监听
        case 'openHouseInfo':
          break
        case 'favoriteHouse':
          break
        default:
      }
    }
  },
  methods: {
    async init() {
      // 获取城市和二三级筛选项映射关系
      const labelStrategyId = this.compProps.mate.filterId
      const labelRes = await fetchSearchLableMapping({ labelStrategyId, wrapperId: 'waptujia016' })
      if (labelRes.ret && labelRes.data) {
        const query = this.$route.query
        const queryCityId = parseInt(query.cityId) || ''
        const queryLabelKey = query.labelkey_2
        const querySubLabelKey = query.labelkey_3
        
        const { labelStrategyMappings } = labelRes.data
        this.labelStrategyMappings = labelStrategyMappings

        // url中有城市id，优先使用url中的城市；url没有，采用映射规则的第一个城市
        let curLabelStrategyCityMapping
        labelStrategyMappings.forEach((labelStrategyCityMapping) => {
          if (labelStrategyCityMapping.cityId === queryCityId) {
            curLabelStrategyCityMapping = labelStrategyCityMapping
          }
        })
        if (curLabelStrategyCityMapping === undefined) {
          curLabelStrategyCityMapping = labelStrategyMappings[0]
        }
        const curCityId = curLabelStrategyCityMapping.cityId
        const curCityName = curLabelStrategyCityMapping.cityName
        const curCity = { cityId: curCityId, cityName: curCityName }
        this.curCity = curCity

        // 当前城市下可选的二级筛选项，需要把b端配置的样式信息添加进去
        const keyIndexMap = {}
        const themeFilters = curLabelStrategyCityMapping.cityLabelList
          .map((labelStrategyMapping, index) => {
            const { labelKey, labelName, level, childList } = labelStrategyMapping
            keyIndexMap[labelKey] = index
            return { labelKey, labelName, level, childList }
          })
        this.compProps.mate.items.forEach((item) => {
          const styleProperties = {
            pageBackground: item.pageBackground,
            selectColor: item.selectColor,
            textColor: item.textColor
          } 
          themeFilters[keyIndexMap[item.labelKey]] = {
            ...themeFilters[keyIndexMap[item.labelKey]],
            ...styleProperties
          }
        })
        this.themeFilters = themeFilters
       
        // url有筛选项参数，优先作为默认选中筛选项; url没有，采用第一个作为默认选中
        let curFilter
        let curSubFilters = []  
        themeFilters.forEach((filter) => {
          if (filter.labelKey === queryLabelKey) {
            curFilter = filter
          }
        })
        if (curFilter === undefined) {
          curFilter = themeFilters[0]
        }
        this.curFilter = curFilter
        const subFilters = curFilter.childList
        if (querySubLabelKey) {
          curFilter.childList.forEach((subFilter) => {
            if (subFilter.labelKey === querySubLabelKey) {
              curSubFilters.push(subFilter)
            }
          })
        }
        const cityList = this.cityList = this.getCityList(labelStrategyMappings)
        let filters = {
          curCity,
          curFilter,
          curSubFilters,
          cityList,
          themeFilters,
          subFilters
        }
        this.$emit('init', { type: 'initFilter', data: filters})

        let labelKeys = []
        labelKeys.push(curFilter.labelKey)
        curSubFilters.forEach((subFilter) => {
          labelKeys.push(subFilter.labelKey)
        })
        this.labelKeys = labelKeys
        this.refreshHouses(curCityId, labelKeys)
      }
    },
    // TODO: 目前城市名称的第一个字是多音字时，可能城市的首字母归类不正确，不能保证正确。
    // 根据城市筛选项的映射关系，生成可以选择的城市列表数据
    getCityList(mappings) {
      // 首字母及所属分组的城市
      const letters = {}
      // 按字母表排序后的城市数据
      const cityList = []
      mappings.forEach((city) => {
        const { cityId, cityName } = city
        const pinYin = convertPinyin(cityName)
        const firstLetter = pinYin[0].toUpperCase()
        // 首字母不存在就新建分组，存在就插入数据
        if (letters[firstLetter]) {
          letters[firstLetter].items.push({
            cityId,
            name: cityName
          })
        } else {
          letters[firstLetter] = {
            name: firstLetter,
            items: [{
              cityId,
              name: cityName
            }]
          }
        }
      })
      // 按字母表顺序生成嵌套数组
      const beginCharCode = 'A'.charCodeAt(0)
      const endCharCode = 'Z'.charCodeAt(0)
      for (let index = beginCharCode; index <= endCharCode; index++) {
        const letter = String.fromCharCode(index)
        if (letters[letter]) {
          cityList.push(letters[letter])
        }
      }

      return cityList
    },
    // 切换城市
    async changeCity(newCity) {
      // 清空已选中筛选项，更新当前城市映射的二三级筛选项
      // 设置筛选项默认值
      
      const labelStrategyMappings = this.labelStrategyMappings
      const curLabelStrategyCityMapping = labelStrategyMappings.filter((cityMapping) => {
        return cityMapping.cityId === newCity.cityId
      })[0]
      const curCityId = curLabelStrategyCityMapping.cityId
      const curCityName = curLabelStrategyCityMapping.cityName
      const curCity = { cityId: curCityId, cityName: curCityName }
      this.curCity = curCity

      // 当前城市的二级筛选项
      const keyIndexMap = {}
      const themeFilters = curLabelStrategyCityMapping.cityLabelList
          .map((labelStrategyMapping, index) => {
            const { labelKey, labelName, level, childList } = labelStrategyMapping
            keyIndexMap[labelKey] = index
            return { labelKey, labelName, level, childList }
          })
      this.compProps.mate.items.forEach((item) => {
        const styleProperties = {
          pageBackground: item.pageBackground,
          selectColor: item.selectColor,
          textColor: item.textColor
        } 
        themeFilters[keyIndexMap[item.labelKey]] = {
          ...themeFilters[keyIndexMap[item.labelKey]],
          ...styleProperties
        }
      })
      this.themeFilters = themeFilters

      const curFilter = themeFilters[0]
      this.curFilter = curFilter
      const subFilters = curFilter.childList

      const cityList = this.cityList
      const filters = {
        curCity,
        curFilter,
        curSubFilters: [],
        cityList,
        themeFilters,
        subFilters
      }
      eventBus.$emit('filter_change', curFilter)
      this.$emit('finish', { type: 'updateFilter', data: filters})

      let labelKeys = []
      labelKeys.push(curFilter.labelKey)
      this.labelKeys = labelKeys
      this.refreshHouses(curCityId, labelKeys)
    },
    // 改变二级筛选项
    changeFilter(newFilter) {
      eventBus.$emit('filter_change', newFilter)
      const { curCity, cityList, themeFilters } = this
      const labelStrategyMappings = this.labelStrategyMappings
      const curLabelStrategyCityMapping = labelStrategyMappings.filter((cityMapping) => {
        return cityMapping.cityId === curCity.cityId
      })[0]
      const curFilter = themeFilters.filter((label) => {
        return label.labelKey === newFilter.labelKey
      })[0]
      this.curFilter = curFilter
      const subFilters = curFilter.childList
      const filters = {
        curCity,
        curFilter,
        curSubFilters: [],
        cityList,
        themeFilters,
        subFilters
      }
      this.$emit('finish', { type: 'updateFilter', data: filters})
      
      let labelKeys = []
      labelKeys.push(curFilter.labelKey)
      this.labelKeys = labelKeys
      // TODO：保证筛选项联动的头图在房屋卡片的图片之前请求，避免头图更新过慢
      setTimeout(() => {
        this.refreshHouses(curCity.cityId, labelKeys)
      }, 50)
      // this.refreshHouses(curCity.cityId, labelKeys)
    },
    // 改变选中的三级筛选项
    changeSubFilter(newSubFilters) {
      const { curCity, curFilter, cityList, themeFilters } = this
      const labelStrategyMappings = this.labelStrategyMappings
      const curLabelStrategyCityMapping = labelStrategyMappings.filter((cityMapping) => {
        return cityMapping.cityId === curCity.cityId
      })[0]
      const subFilters = curFilter.childList
      const filters = {
        curCity,
        curFilter,
        curSubFilters: newSubFilters,
        cityList,
        themeFilters,
        subFilters
      }
      this.$emit('finish', { type: 'updateFilter', data: filters})
      // labelKeys代表选中的二三级筛选项集合
      let labelKeys = []
      labelKeys.push(curFilter.labelKey)
      newSubFilters.forEach((subFilter) => {
        labelKeys.push(subFilter.labelKey)
      })
      this.labelKeys = labelKeys
      this.refreshHouses(curCity.cityId, labelKeys)
    },
     // 加载更多房屋
    loadMore(data) {
      const { curCity, labelKeys } = this
      const { pageIndex } = data
      this.refreshHouses(curCity.cityId, labelKeys, pageIndex)
    },
    // 刷新房屋数据
    async refreshHouses(cityId, labelKeys = [], pageIndex = 1) {
      const { privateProps } = this.compProps.mate
      const aIds = (this.compProps.promotionId && this.compProps.promotionId.split(',')) || []
      const houseIds = (privateProps.houseList[cityId] && privateProps.houseList[cityId]
        .map((item) => {
          return item.id
        })) || []
      
      // 入离店日期优先取url中的入离日期（app传入）
      const query = this.$route.query
      const date = new Date()
      let fromDate
      let toDate
      if (query.fromDate && query.toDate) {
        fromDate = format('yyyy-MM-dd', new Date(query.fromDate))
        toDate = format('yyyy-MM-dd', new Date(query.toDate))
      } else {
        fromDate = format('yyyy-MM-dd', date)
        toDate = format('yyyy-MM-dd', new Date(date.getTime() + ONE_DAY))
      }
      this.fromDate = fromDate
      this.toDate = toDate
      let params = {
        parameter: {
          checkInDate: this.fromDate,
          checkOutDate: this.toDate,
          cityId: cityId,
          filters: labelKeys,
          topShowUnitIds: houseIds,
          pageIndex: pageIndex,
          pageSize: 30
        }
      }
      const houseData = await qFetchHouseWithFilter(params)
      const ret = houseData.value || {}
      console.log(ret)
      const faviroteIds = await QFetchFaviroteList()
      let total = (ret.data && ret.data.totalCount) || 0
      let items = (ret.data && ret.data.items) || []
      let maxShowNumber = this.compProps.mate.maxShowNumber
      let hasPriceTags = false
      let hasSpecialTags = false
       items = items && items.map((item) => {
        let house = item
        if (this.compProps.houseChoice === '0') {
          house = this.compProps.houses.find((itemHouse) => {
            return itemHouse.id + '' === item.unitId + ''
          })
        }
        const favirote = faviroteIds.find((faviroteId) => {
          return faviroteId + '' === item.unitId + ''
        })
        let priceTags = item.priceTags || []
        if (this.compProps.mode === '2') {
          priceTags = item.priceTags && item.priceTags.splice(0, 1)
        }
        if (priceTags && priceTags.length > 0) {
          hasPriceTags = true
        }
        let specialTags = item.specialTags || []
        if (specialTags.length > 0) {
          hasSpecialTags = true
        }
        return {
          ...item,
          priceTags,
          comment: house.comment,
          houseLabels: house.labels,
          isLike: favirote !== undefined
        }
      })
      items = items && items.map((item) => {
        return {
          ...item,
          hasPriceTags,
          hasSpecialTags
        }
      })
      if (pageIndex === 1) {
        this.$emit('init', {
          type: 'initHouse',
          data: {
            totalCount: total,
            items: items,
            pageIndex,
            maxShowNumber: parseInt(maxShowNumber)
          }
        })
      } else {
        this.$emit('finish', {
          type: 'loadMoreHouses',
          data: {
            totalCount: total,
            items: items,
            pageIndex,
            maxShowNumber: parseInt(maxShowNumber)
          }
        })
      }
    },
    // 透传子servComp组件finish事件到UiComp组件
    finishHandle(payLoad) {
      this.$emit('finish', payLoad)
    }
  }
}
</script>
